import { render, staticRenderFns } from "./CaseDetail.vue?vue&type=template&id=28b97b3e&scoped=true&"
import script from "./CaseDetail.vue?vue&type=script&lang=ts&"
export * from "./CaseDetail.vue?vue&type=script&lang=ts&"
import style0 from "./CaseDetail.vue?vue&type=style&index=0&id=28b97b3e&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28b97b3e",
  null
  
)

export default component.exports